import React, { useCallback } from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import Link from 'next/link'
import { themeGet } from '@styled-system/theme-get'
import { useRouter } from 'next/router'
import {
	PRODUCTS_HANDOUT_PAGE,
	PRODUCTS_TEXTBOOK_PAGE,
	PRODUCTS_WORKBOOK_PAGE,
} from '@/settings/constant'

const ProductSearchResultHeaderWrapper = styled.div`
	@media (max-width: 1200px) {
		padding: 0 36px;
	}
	@media (max-width: 768px) {
		padding: 0 16px;
	}
`

const ResultHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 16px;

	.title {
		font-size: 20px;
		font-weight: bold;

		@media (max-width: 1200px) {
		}
		@media (max-width: 768px) {
			font-size: 16px;
		}
	}

	.categoryName {
		font-size: 20px;
		font-weight: bold;
		color: ${themeGet('text.0', '#1B1B29')};

		.dataNumber {
			font-size: 16px;
			font-weight: bold;
			color: rgba(27, 27, 41, 0.3);
			margin-left: 8px;

			@media (max-width: 1200px) {
			}
			@media (max-width: 768px) {
				font-size: 14px;
			}
		}
	}

	.ant-btn {
		height: auto;
		padding: 0 16px;
		margin-right: -16px;

		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}

		span {
			vertical-align: middle;
			font-size: 16px;
			color: ${themeGet('text.0', '#1B1B29')};
		}

		.anticon {
			position: relative;
			display: inline-block;
			vertical-align: baseline;
			margin-left: 4px;

			&:before {
				display: inline-block;
				content: '';
				vertical-align: middle;
				width: 16px;
				height: 16px;
				background: url('/static/assets/right_strong_black.svg') no-repeat center center;
				background-size: contain;
			}

			svg {
				display: none;
			}
		}

		@media (max-width: 1200px) {
			display: none;
		}
		@media (max-width: 768px) {
		}
	}
`

export interface ProductSearchResultHeaderProps {
	/* 검색결과 타이틀: N */
	title: string

	/* 수업자료: N */
	count: number

	/* 더보기: N */
	onShowMore?: () => void

	goToUrl?: string
}

export const ProductSearchResultHeader: React.FC<ProductSearchResultHeaderProps> = ({
	title,
	count,
	onShowMore,
	goToUrl,
}) => {
	const router = useRouter()
	const handleOnShowMore = useCallback(() => {
		if (title === '수업자료') {
			router.push(PRODUCTS_HANDOUT_PAGE)
		} else if (title === '교과서') {
			router.push(PRODUCTS_WORKBOOK_PAGE)
		} else if (title === '참고서') {
			router.push(PRODUCTS_TEXTBOOK_PAGE)
		}
	}, [onShowMore])
	return (
		<ProductSearchResultHeaderWrapper>
			<ResultHeader>
				<div className="categoryName">
					<span className="title">{title}</span>
					<span className="dataNumber">{count}건</span>
				</div>

				{goToUrl ? (
					<Link href={goToUrl} passHref={true} legacyBehavior={true}>
						<Button
							type={'link'}
							// size={'small'}
							// icon={<RightOutlined />}
							onClick={handleOnShowMore}>
							더보기
							<RightOutlined />
						</Button>
					</Link>
				) : (
					<Button
						type={'link'}
						// size={'small'}
						// icon={<RightOutlined />}
						onClick={handleOnShowMore}>
						더보기
						<RightOutlined />
					</Button>
				)}
			</ResultHeader>
		</ProductSearchResultHeaderWrapper>
	)
}
